/* eslint-disable no-console */
import { grey } from "kleur/colors";
// const bee = `\u{1F41D}`;
const debug = `\u{1F3F7}`;
const tick = `\u{2705}`;
const error = `\u{2757}`;
const warning = `\u{26A0}`;
const info = `\u{2139}`;
const fatal = `\u{203C}`;
const play = `\u{1F41D}`;
export class Logger {
    constructor(module) {
        this._prefix = `${grey(`Zigzag`)} ${grey(`[${module}]`)}`;
    }
    debug(message) {
        console.log(`${this._prefix} ${debug} ${message}`);
    }
    error(message) {
        console.log(`${this._prefix} ${error} ${message}`);
    }
    fatal(message) {
        console.log(`${this._prefix} ${fatal} ${message}`);
    }
    info(message) {
        console.log(`${this._prefix} ${info} ${message}`);
    }
    success(message) {
        console.log(`${this._prefix} ${tick} ${message}`);
    }
    start(message) {
        console.log(`${this._prefix} ${play} ${message}`);
    }
    warn(message) {
        console.log(`${this._prefix} ${warning} ${message}`);
    }
}
/* eslint-enable no-console */
